import NavigationHeader from '@Front/modules/navigation/components/navigationHeader';
import NavigationFooter from '@Front/modules/navigation/components/navigationFooter';
import { ComponentLoader } from '@bythepixel/component-loader';

window.navHeaderComponents = new ComponentLoader(document, [NavigationHeader]);
if (document.querySelector('.page-footer')) {
  window.navFooterComponents = new ComponentLoader(document.querySelector('.page-footer'), [NavigationFooter]);
}
